/***********************************************************************************************************************
 *  Элемент роута (AppRoute)
 */
export default class AppRoute {

    /**
     * AppRoute
     *
     * @param {?string} path - если null считает как разделитель либо спецсимвол()
     * @param {?JSX.Element} element
     * @param {?string} link - абсолютная ссылка в меню начинается с '/', если null, то ссылка скрыта
     * @param {string} label
     * @param {AppRoute[]} children
     */
    constructor({ path=null, element=null, link=null, label='', children=[] }={}) {
        this.path = path
        this.link = link
        this.element = element
        this.label = label
        this.children = children
    }


    /**
     * @param path
     * @param element
     * @param label
     * @param link
     * @param children
     * @returns {AppRoute}
     */
    copyWith({ path, element, link, label, children }) {
        return new AppRoute({
            path:       path !== undefined ? path : this.path,
            element:    element !== undefined ? element : this.element,
            link:       link !== undefined ? link : this.link,
            label:      label !== undefined ? label : this.label,
            children:   children !== undefined ? children : this.children
        });
    }

}
